import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=e8fa4e32&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=e8fa4e32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fa4e32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8fa4e32')) {
      api.createRecord('e8fa4e32', component.options)
    } else {
      api.reload('e8fa4e32', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=e8fa4e32&scoped=true&", function () {
      api.rerender('e8fa4e32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SwBIqHg4LGK4/JS/teamMember.vue"
export default component.exports